module.exports = __webpack_public_path__ + "img/machine_test.adf46b01.png";